// src/components/audition-booking-wizard/scheduler/TimeGrid.jsx
import React from 'react';
import { Spinner } from 'react-bootstrap';

const TimeGrid = ({ loadingSlots, filteredSlots, selectedTimeSlot, setSelectedTimeSlot, setSelectedSlotId }) => {
    return (
        <div className="time-grid mt-3">
            {loadingSlots && <Spinner className="text-white" animation="border" size="sm" />}
            {!loadingSlots && filteredSlots.length > 0 ? (
                filteredSlots.map((slot, index) => (
                    <button
                        key={index}
                        className={`time-pill ${selectedTimeSlot === slot.timeOnly ? "active" : ""}`}
                        onClick={() => {
                            setSelectedTimeSlot(slot.timeOnly);
                            setSelectedSlotId(slot.id); // Store slot ID
                        }}
                    >
                        {slot.timeOnly}
                    </button>
                ))
            ) : (
                !loadingSlots && <div className="text-center text-light mt-3">No slots available for this date.</div>
            )}
        </div>
    );
};

export default TimeGrid;